import {
  OnCompanyUserChangedDocument,
  TListAdminCognitoUsersQuery,
  TListAdminCognitoUsersQueryVariables,
  TListUsersIncludingCsUsersQuery,
  TListUsersIncludingCsUsersQueryVariables,
  TOnCompanyUserChangedSubscriptionVariables,
  TUserFieldsFragment,
  useListAdminCognitoUsersLazyQuery,
  useListUsersIncludingCsUsersLazyQuery
} from '../../generated/graphql';
import { useQueryAll } from '../shared/useQueryAll';

export type TManagerAccount = { name: string; id: string };

export type TUserType = TUserFieldsFragment;

export const useQueryAllUsers = (variables: TListUsersIncludingCsUsersQueryVariables) => {
  const { data, error, loading } = useQueryAll<TListUsersIncludingCsUsersQuery, TListUsersIncludingCsUsersQueryVariables, TOnCompanyUserChangedSubscriptionVariables>({
    subscriptionDoc: OnCompanyUserChangedDocument,
    subscriptionVariables: {
      companyId: variables.companyId
    },
    useQuery: useListUsersIncludingCsUsersLazyQuery,
    variables
  });

  return {
    data: (data?.listUsersIncludingCSUsers.items || []) as TUserType[],
    error: error,
    loading: loading
  };
};

export const useListCognitoUsersNew = (userPoolId: string = import.meta.env.REACT_APP_COGNITO_USER_POOL_ID as string, onlyCS = false) => {
  const { data, loading, error } = useQueryAll<TListAdminCognitoUsersQuery, TListAdminCognitoUsersQueryVariables>({
    useQuery: useListAdminCognitoUsersLazyQuery,
    variables: { userPoolId, onlyCS },
    fetchPolicy: 'network-only'
  });

  return {
    data: data?.listAdminCognitoUsers || {},
    loading,
    error
  };
};
